export default {
  id: 0,
  name: '',
  code: '',
  phone_prefix: '',
  updated_at: '',
  created_at: ''
}
